import BaseService from "./BaseService";

export default {
    index() {
        return BaseService.get('/users');
    }
}